document.addEventListener(
    "DOMContentLoaded",
    () => {
        initCrossSellSplide();
		mmInitAnnouncesSplide();
    },
    { once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/*********************************************************************************************
* Get the full cart section ID from the DOM.
	*
	* @returns {HTMLElement} - The full cart section ID with the prefix.
*/
function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart').id;
}

/*********************************************************************************************
* Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
	*
	* @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
*/
function mmCartSectionId() {
	return document.querySelector('.mm-cart').id.replace('shopify-section-', '');
}

/*********************************************************************************************
* Get the cart section element from the DOM.
	*
	* @returns {HTMLElement} - The cart section element.
*/
function mmCartSectionElement() {
    return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
* Get the cart product container element from the cart section.
	*
	* @returns {HTMLElement} - The cart product container element.
*/
function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.value);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);
        
        if (quantityEl) {
            quantityEl.dataset.itemQuantity = newQuantity;
            if (quantityEl.value) {
                quantityEl.value = newQuantity;
            }
            
            // Mettre à jour l'option sélectionnée dans le select
            const selectEl = quantityEl.closest('select');
            if (selectEl) {
                const options = selectEl.options;
                for (let i = 0; i < options.length; i++) {
                    if (parseInt(options[i].value) === newQuantity) {
                        options[i].selected = true;
                        break;
                    }
                }
            }
        }
    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    el.innerHTML = data.sections["mm-cart"];

    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            // mmLog(data);
            document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
			// console.log('data.item_count', data.item_count)
            updateCartCount(data.item_count != null ? data.item_count : 0);
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart(fromBottom = false) {
    const cartFilter = document.querySelector(".mm-drawer-cart-filter");
    const cartTrigger = document.getElementById("mmOpenCartButton");

    // Access
    cartTrigger.setAttribute("aria-expanded", "true");
    cartFilter.hidden = false;
    cartFilter.setAttribute("aria-hidden", "false");
    cartFilter.querySelector(".mm-drawer-cart-close")?.focus();
    initFocusTrap(document.querySelector(".mm-drawer-cart"), { onEscape: mmCloseCart });
  
    if (fromBottom) {
        cartFilter.classList.add("mm-dc-from-bottom");
    } else {
        cartFilter.classList.remove("mm-dc-from-bottom");
    }
    cartFilter.classList.add("mm-dc-is-open");
    document.querySelector('html').classList.add('stop-scrolling');
    mmGetCart();

    // Handle Filter
    document.querySelector(".mm-filter-mega-menu").classList.add("active");
    document.querySelector(".mm-filter-mega-menu").style.zIndex = "20";
    mmInitAnnouncesSplide();
}

// Fermer le panier
function mmCloseCart() {
    const cartFilter = document.querySelector(".mm-drawer-cart-filter");
    const cartTrigger = document.getElementById("mmOpenCartButton");

    // Access
    cartTrigger.setAttribute("aria-expanded", "false");
    cartFilter.hidden = true;
    cartFilter.setAttribute("aria-hidden", "true");
  
    document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
	document.querySelector(".mm-filter-mega-menu").classList.remove("active");
	document.querySelector('html').classList.remove('stop-scrolling');

    // Handle Filter
	document.querySelector(".mm-filter-mega-menu").style.zIndex = "5";
	document.querySelector('.mm-header').classList.remove('mm-header-scrolled');
	document.querySelector('.mm-section-announcement-bar').classList.remove('mm-header-scrolled');

    cartTrigger.focus();
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections[mmCartSectionId()];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
	updateCartCount(newCartEl.querySelector('[data-cart-count]').dataset.cartCount);
	mmInitAnnouncesSplide();
	initCrossSellSplide();
	setupLenis();
    return data;
}

function mmGetCartItemQuantityForVariant(variantId) {
    let totalQuantity = 0;
    const items = document.querySelectorAll(`[data-cart-item-id="${variantId}"]`);
    items.forEach(item => {
        const quantityEl = item.querySelector("[data-item-quantity]");
        if (quantityEl && quantityEl.value) {
            totalQuantity += parseInt(quantityEl.value);
        }
    });
    return totalQuantity;
}

function mmAddProductToCart(productId, quantity = 1, { openCart = true, fromPcSize = false } = {}) {
    // Vérifier le stock disponible
    const variantEl = document.querySelector(`[data-variant-id="${productId}"]`);
    if (variantEl) {
        const maxQuantity = parseInt(variantEl.dataset.inventoryQuantity || 0);
        const currentCartQuantity = mmGetCartItemQuantityForVariant(productId);
        
        // Si la quantité totale (panier + ajout) dépasse le stock disponible
        if (maxQuantity > 0 && (currentCartQuantity + quantity) > maxQuantity) {
            // Optionnel : afficher un message d'erreur
            alert(`Désolé, il ne reste que ${maxQuantity - currentCartQuantity} unité(s) disponible(s)`);
            return;
        }
    }

    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: productId }],
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData)
    .then((data) => {
        if (openCart) {
            setTimeout(() => mmOpenCart(fromPcSize));
        }
    })
    .catch((error) => {
        console.log(`
            Oups, il y a eu une erreur, essayez de recharger la page !
        `);
        mmOpenCart(fromPcSize);
        console.log(error);
    });
}

function mmChangeProductQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);
    if (!quantityEl) return;
    
    const quantity = parseInt(quantityEl.value);
    const inventoryPolicy = quantityEl.dataset.inventoryPolicy;
    const maxQuantity = parseInt(quantityEl.dataset.inventoryQuantity || 0);
    
    // Si c'est un produit en précommande ou si la quantité est valide
    if (inventoryPolicy === 'continue' || quantity <= maxQuantity) {
        mmDebouncedPushNewQuantity(productVariantId);
    } else if (maxQuantity > 0 && quantity > maxQuantity) {
        // Si on dépasse le stock disponible, on revient à la quantité maximale
        mmSetCartItemQuantity(productVariantId, maxQuantity);
        mmDebouncedPushNewQuantity(productVariantId);
    }
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    // Mettre la quantité à 0 dans l'interface
    const newQuantity = '0';
    mmSetCartItemQuantity(productVariantId, newQuantity);

    // Envoyer directement la requête de suppression sans passer par le debounce
    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

function mmPushNewQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);
    if (!quantityEl) return;
    
    const quantity = parseInt(quantityEl.value);
    
    // Si la quantité est 0, on supprime directement l'article
    if (quantity === 0) {
        mmAPIRequest("POST", "cart/change.js", {
            id: productVariantId.toString(),
            quantity: 0,
            sections: mmCartSectionId(),
        })
        .then(refreshCartFromData);
        return;
    }

    // Pour les autres cas, on vérifie le stock
    const inventoryPolicy = quantityEl.dataset.inventoryPolicy;
    const maxQuantity = parseInt(quantityEl.dataset.inventoryQuantity || 0);
    
    // Si c'est un produit en précommande ou si la quantité est valide
    if (inventoryPolicy === 'continue' || quantity <= maxQuantity) {
        mmAPIRequest("POST", "cart/change.js", {
            id: productVariantId.toString(),
            quantity: quantity,
            sections: mmCartSectionId(),
        })
        .then(refreshCartFromData);
    }
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) {
    // Debounce sur le CTA
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");

    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: 1, id: productVariantIdToAdd }],
        sections: mmCartSectionId(),
    }).then(mmDestroyProductFromCart(productVariantIdToRemove));
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections[mmCartSectionId()]) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector("[data-free-products]");
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct == "true";
            const itemEl = mmCartItem(productId);
            if (isFree) {
                freeProductCounts += 1;
            }
            if (itemEl && isFree) {
                console.log("do nothing, item is already added");
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                console.log("item is present but should be removed");
                // item is present but should be removed
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                console.log("item is absent but should be added", productId);
                // item is absent but should be added
                param[productId] = 1;
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            console.log("productsParams", productsParams);
            mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: mmCartSectionId() }).then(refreshCartFromData);
        }
    }
    return data;
}

function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce sur le CTA
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

window.addEventListener("DOMContentLoaded", (event) => {
    mmGetCart();
});

function updateCartCount(value) {
    var cartCountValues = document.querySelectorAll('.cart-count-bubble');
	cartCountValues.forEach(function(element) {
        element.innerText = value;
    });
}

// SPLIDE ANNOUNCES BAR //

function mmInitAnnouncesSplide() {
	var id = '.splide-announces-bar';
	var splideElem = document.querySelector(id);

	new Splide( splideElem, {
		type: 'slide',
		autoplay: true,
		rewind: true,
		arrows: false,
		pagination: false,
		perPage: 1,
		gap: 8
	}).mount();
};

// SPLIDE CROSS-SELL ITEMS //

function initCrossSellSplide() {
    var id = '.splide-cross-sell';
    var splideElem = document.querySelector(id);
    
    // Vérifier si l'élément existe avant d'initialiser Splide
    if (!splideElem) return;

    let splide = new Splide(splideElem, {
        type: 'slide',
        arrows: true,
        pagination: false,
        gap: 5,
        perPage: 2,
        direction: 'ltr',
        waitForTransition: true,
        wheel: false, // Désactiver wheel car peut causer des problèmes
        breakpoints: {
            768: {
                perPage: 1,
                perMove: 1 // Modifier pour un défilement plus fluide
            }
        }
    });

    // Vérifier si la barre de progression existe
    var bar = splideElem.querySelector('.my-slider-progress-bar');
    
    if (bar) {
        splide.on('mounted move', function() {
            var end = splide.Components.Controller.getEnd() + 1;
            var rate = Math.min((splide.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + '%';
        });
    }

    splide.mount();
}

// Full width to dynamic checkout button
function mmAddCssToShadowDOM() {
  const shadowHost = document.querySelector('shopify-accelerated-checkout-cart');

  //console.log('shadowHost', shadowHost)
  //console.log('shadowHost.shadowRoot', shadowHost.shadowRoot)

  // Vérifier que le Shadow DOM existe déjà
  if (shadowHost && shadowHost.shadowRoot) {
    const shadowRoot = shadowHost.shadowRoot;

    const style = document.createElement('style');
    style.textContent = `
      .wallet-cart-button-container {
        width: 100% !important;
      }
    `;

    shadowRoot.appendChild(style);
  } else {
    console.error('Shadow root non trouvé ou composant non chargé');
  }
}

document.addEventListener("DOMContentLoaded", mmAddCssToShadowDOM);
